import { render, staticRenderFns } from "./InterConnectionsSelect.vue?vue&type=template&id=60487dcb&scoped=true&"
import script from "./InterConnectionsSelect.vue?vue&type=script&lang=js&"
export * from "./InterConnectionsSelect.vue?vue&type=script&lang=js&"
import style0 from "./InterConnectionsSelect.vue?vue&type=style&index=0&id=60487dcb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60487dcb",
  null
  
)

export default component.exports